export enum ErrorMessage {
	CodAA05 = 'Ha ocurrido un error con la verificacion, por favor comunicarse con el centro de autorizaciones o intente nuevamente.', //Este codigo esta en el AA,
	ParameterValuesError = 'AA-0000-0002',
	AASException = 'AA-0000-0019',
	InvalidMAC = 'Se ha agotado el tiempo de espera para procesar la solicitud. Por favor reinicia el proceso.',
	GenericError = 'Ha ocurrido un error inesperado. Por favor, reintente',
	NoBiometryFromUrlError = 'Error al leer la URL. Por favor, reintente',
	SessionDataError = 'Error al leer la informacion. Por favor, reintente',
}
